import Table from "../../components/Table.jsx";

<br/>

<img className={`radius`} src={new URL('../../img/access/soki_i_studenci.png', import.meta.url)} alt="studenci pijacy soki w barze"/>

<br/>

W tej lekcji przejdziemy przez parę prostych zapytań napisanych w języku SQL. Zaczniemy od bardzo prostych zadań wykorzystujących tylko jedną tabelę, a potem przejdziemy do nieco trudniejszych aż to bardziej zaawansowanych.
Pamiętajmy jednak, że pokrywamy tutaj tylko podstawy. Powinny one wystarczyć na część pisemną matury z informatyki i zadania z SQL-a, które możemy na nich znaleźć.
Jak już podkreślaliśmy, jeśli chcemy dogłębniej zrozumieć ten język i nauczyć się więcej to warto poza rozwiązaniami w Access ćwiczyć dodatkowo pisanie zapytań SQL.


## Dane do przykładowych zadań

<br/>

**Tabela: Soki**
<Table
header = {["Smak", "Pojemność", "Cena"]}
data = {[
        ["Jabłkowy", "330", "5,00"],
        ["Pomarańczowy", "250", "5,00"],
        ["Porzeczkowy", "250", "4,5"],
        ["Grejpfrutowy", "330", "6,00"],
        ["Kaktusowy", "125", "4,5"]
        ]}
/>

<br/>

**Tabela: Bary**
<Table
header = {["Nazwa", "Adres", "Godzina zamknięcia"]}
data = {[
        ["Przekręt", "Grunwaldzka 15", "1:30"],
        ["Piątak", "Kazimierza 35", "2:00"],
        ["Witaminka", "Rynek 50", "21:00"],
        ["Literatka", "Rynek 48", "0:00"],
        ]}
/>
    
<br/>

**Tabela: Studenci**
<Table
header = {["Indeks", "Imię", "Nazwisko", "Rok studiów"]}
data = {[
        ["342335", "Jan", "Pilny", "I"],
        ["328990", "Kazimierz", "Dostateczny", "III"],
        ["315737", "Amelia", "Celująca", "V"],
        ["346902", "Justyna", "Spokojna", "I"],
        ]}
/>    

<br/>

**Tabela: LubianeSoki**
<Table
header = {["Indeks", "Sok"]}
data = {[
        ["342335", "Jabłkowy"],
        ["342335", "Porzeczkowy"],
        ["328990", "Jabłkowy"],
        ["315737", "Pomaranczowy"],
        ["315737", "Kaktusowy"],
        ["315737", "Grejfrutowy"],
        ]}
/>   

<br/>

**Tabela: LubianeBary**
<Table
header = {["Indeks", "Bar"]}
data = {[
        ["342335", "Przekret"],
        ["342335", "Witaminka"],
        ["328990", "Przekret"],
        ["315737", "Przekret"],
        ["315737", "Piatak"],
        ["346902", "Literatka"],
        ]}
/>  

<br/>

**Tabela: PodawaneSoki**
<Table
header = {["Indeks", "Sok"]}
data = {[
        ["Przekręt", "Jabłkowy"],
        ["Przekręt", "Porzeczkowy"],
        ["Przekręt", "Grejfrutowy"],
        ["Przekręt", "Kaktusowy"],
        ["Piątak", "Jabłkowy"],
        ["Piątak", "Porzeczkowy"],
        ["Witaminka", "Jabłkowy"],
        ["Witaminka", "Pomaranczowy"],
        ["Witaminka", "Kaktusowy"],
        ["Literatka", "Grejfrutowy"],
        ]}
/>  
    
<img src={new URL('../../img/access/soki_bary_diagram.png', import.meta.url)} alt="studenci pijacy soki w barze" />

<br/> <br/> <br/>


## **Chcemy zapytać o:**

### 0. Całą zawartość tabeli Soki.
```sql
SELECT *
FROM Soki;
```
<Table
header = {["Smak", "Pojemność", "Cena"]}
data = {[
        ["Jabłkowy", "330", "5,00"],
        ["Pomarańczowy", "250", "5,00"],
        ["Porzeczkowy", "250", "4,5"],
        ["Grejpfrutowy", "330", "6,00"],
        ["Kaktusowy", "125", "4,5"]
        ]}
/>

**Wytłumaczenie**: operator "*" oznacza "weź wszystko". W tym przypadku weź wszystko z tabeli Soki.
    
### 1. Smaki soków, które są pojemności 330ml.  

```sql
SELECT Smak
FROM Soki
WHERE Pojemnosc = 330; 
```
<Table
    header = {["Smak"]}
    data = {[
            ["Jabłkowy"],
            ["Grejfrutowy"],
            ]}
/>

    
### 2. Soki które są tańsze niż 5,80zł.

```sql
SELECT Smak
FROM Soki
WHERE Cena < 5,80; 
```
<Table
    header = {["Smak"]}
    data = {[
            ["Jabłkowy"],
            ["Pomarańczowy"],
            ["Porzeczkowy"],
            ["Kaktusowy"],
            ]}
/>

                  

### 3. Soki, które są tańsze niż 2 zł za 100ml 

```sql
SELECT Smaki
FROM Soki
WHERE ((Cena/Pojemnosc)*100) < 2; 
```
<Table
    header = {["Smak"]}
    data = {[
            ["Jabłkowy"],
            ["Porzeczkowy"],
            ["Grejfrutowy"],
            ]}
/>


### 4. Cenę za 100ml dla każdego z soków w kolejności niemalejącej

```sql
SELECT Smak, ((Cena/Pojemnosc)*100) AS Cena_za_100_ml
FROM Soki
ORDER BY Cena_za_100_ml ASC;
```
<Table
    header = {["Smak", "Cena_za_100_ml"]}
    data = {[
            ["Jabłkowy", "1,51515151515152"],
            ["Porzeczkowy", "1,8"],
            ["Grejfrutowy", "1,81818181818182"],
            ["Pomarańczowy", "2"],
            ["Kaktusowy", "3,6"]
            ]}
/>

### 5. Jak w punkcie 4. ale zawsze chcemy widzieć kwote zaokragloną w gorę do pełnych złotówek.

 ```sql
SELECT Smak, CEILING((Cena/Pojemnosc)*100) AS Cena_za_100_ml
FROM Soki
ORDER BY Cena_za_100_ml ASC;
```  
<Table
    header = {["Smak", "Cena_za_100_ml"]}
    data = {[
            ["Jabłkowy", "2"],
            ["Porzeczkowy", "2"],
            ["Grejfrutowy", "2"],
            ["Pomarańczowy", "2"],
            ["Kaktusowy", "4"]
            ]}
/>  

### 6. Zestawienie wszystkich soków lubianych przez studentów.

```sql
SELECT Studenci.Imie, Studenci.Nazwisko, LubianeSoki.Sok
FROM Studenci
JOIN LubianeSoki ON Studenci.Indeks = LubianeSoki.Indeks;
```   
<Table
    header = {["Imie", "Nazwisko", "Sok"]}
    data = {[
            ["Amelia", "Celujaca", "Pomaranczowy"],
            ["Amelia", "Celujaca", "Kaktusowy"],
            ["Amelia", "Celujaca", "Grejfrutowy"],
            ["Kazimierz", "Dostateczny", "Jabłkowy"],
            ["Jan", "Pilny", "Jabłkowy"],
            ["Jan", "Pilny", "Porzeczkowy"]
            ]}
/>     

### 7. Wszystkich studentów, którzy lubią sok Jabłkowy.

```sql
SELECT Studenci.Imie, Studenci.Nazwisko, LubianeSoki.Sok
FROM Studenci
JOIN LubianeSoki ON Studenci.Indeks = LubianeSoki.Indeks
WHERE LubianeSoki.Sok="Jabłkowy";
```
<Table
    header = {["Imie", "Nazwisko", "Sok"]}
    data = {[
            ["Kazimierz", "Dostateczny", "Jabłkowy"],
            ["Jan", "Pilny", "Jabłkowy"],
            ]}
/>  

### 8. Wszystkie bary, w których podają jakiś sok, który lubi Jan Pilny (zadanie ponadprogramowe).

```sql
SELECT PodawaneSoki.Bar
FROM Studenci 
JOIN PodawaneSoki ON Studenci.Indeks = LubianeSoki.Indeks
JOIN Soki ON PodawaneSoki.Sok = Soki.Smak
JOIN LubianeSoki ON Soki.Smak = LubianeSoki.Sok 
WHERE (Studenci.Imie="Jan") AND (Studenci.Nazwisko="Pilny")
GROUP BY PodawaneSoki.Bar;
```  
<Table
    header = {["Bar"]}
    data = {[
            ["Piątak"],
            ["Przekręt"],
            ["Witaminka"],
            ]}
/>

<br/>

## PS - gdzie szukać przykładów

Po więcej przykładów zerknijcie do zakładki "Zadania z baz danych".
Niezmienne również zachęcamy do korzystania ze zbioru maturalnego udostępnianego przez CKE.
    